import styled from 'styled-components';
import { Paragraph } from 'evergreen-ui';

const SmallMutedParagraph = styled(Paragraph)`
  font-weight: 300;
  font-size: 12px;
  line-height: 20px;
  color: #6d6e75;
  opacity: 0.5;
`;

export default SmallMutedParagraph;
